import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { BorderedInput } from '@navi/web-ui/lib/primitives';
import React, { useEffect } from 'react';
import styles from '../index.module.scss';
import { IRenderingEngine, TIMESCOPE } from '../interfaces/index.type';
import { calcultateDateDeltaMinutes, dateFormat } from 'src/utils/DateHelper';
import { DATE_TIME_TYPE } from '@cp/src/components/DateTimePicker/constants';
import DateTimePickerComponent from '@cp/components/DateTimePicker/DateTimePickerComponent';
import dayjs from 'dayjs';

const Time: React.FC<IRenderingEngine> = props => {
  const { question, register, error, source, setValue, unregister, clearErrors, getValue } = props;
  const { text, mandatory, defaultValue, referenceId, supportedDateType } = question;
  const dateBeforeTwohoursFromNow = calcultateDateDeltaMinutes(new Date(), -60);
  const dateAfterTwohoursFromNow = calcultateDateDeltaMinutes(new Date(), +60);
  const defaultDateValue =
    supportedDateType === TIMESCOPE.PAST
      ? dateBeforeTwohoursFromNow
      : supportedDateType === TIMESCOPE.FUTURE
      ? dateAfterTwohoursFromNow
      : new Date();

  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}`, undefined);
      unregister(`${source}_${referenceId}`);
      clearErrors(`${source}_${referenceId}`);
    };
  }, []);
  const handleOnTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setValue(`${source}_${referenceId}`, value);
  };

  return (
    <div className={styles.input}>
      <DateTimePickerComponent
        type={DATE_TIME_TYPE.TIME}
        {...register(`${source}_${referenceId}`, {
          required: mandatory
        })}
        id={`${source}_${referenceId}`}
        name={`${source}_${referenceId}`}
        containerClasses={styles.feedbackDatePicker}
        inputClasses={styles.feedbackDatePickerInput}
        iconColor={'black'}
        value={getValue(`${source}_${referenceId}`)}
        onChange={handleOnTimeChange}
      />
    </div>
  );
};

export default Time;
